// src/config/api.js
// API Configuration for connecting to Django Backend

const API_CONFIG = {
  // Base URL for API calls - Development URL
  BASE_URL: (process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000').replace(/\/$/, ''),
  
  // API Endpoints
  ENDPOINTS: {
    // Authentication
    LOGIN: '/api/token/',
    REFRESH_TOKEN: '/api/token/refresh/',
    USER_INFO: '/chatbot/me/',
    
    // Client Endpoints
    CLIENT_STATS: '/chatbot/stats/',
    CLIENT_CONVERSATIONS: '/chatbot/conversations/',
    CLIENT_CONVERSATION_DETAIL: (id) => `/chatbot/conversations/${id}/`,
    CLIENT_KNOWLEDGE_BASE: '/chatbot/knowledge-base/',
    CLIENT_TOKEN_CHART: '/chatbot/charts/tokens/',
    CLIENT_CONVERSATION_CHART: '/chatbot/charts/conversations/',
    CLIENT_SUGGESTIONS: '/chatbot/suggestions/',
    CLIENT_CAMPAIGNS: '/chatbot/campaigns/',
    CLIENT_CAMPAIGN_DETAIL: (id) => `/chatbot/campaigns/${id}/`,
    CLIENT_CAMPAIGN_RECIPIENTS: (id) => `/chatbot/campaigns/${id}/recipients/`,
    CLIENT_CAMPAIGN_RUN_NOW: (id) => `/chatbot/campaigns/${id}/run-now/`,
    CLIENT_CAMPAIGN_RETRY_FAILED: (id) => `/chatbot/campaigns/${id}/retry-failed/`,
    
    // Admin Endpoints
    ADMIN_CLIENTS: '/admin-api/clients/',
    ADMIN_CLIENT_DETAIL: (id) => `/admin-api/clients/${id}/`,
    ADMIN_CLIENT_STATS: (id) => `/admin-api/clients/${id}/stats/`,
    ADMIN_CLIENT_UPDATE: (id) => `/admin-api/clients/${id}/update/`,
    ADMIN_CLIENT_TEST_OURSMS: (id) => `/admin-api/clients/${id}/test-oursms/`,
    ADMIN_CLIENT_DELETE: (id) => `/admin-api/clients/${id}/delete/`,
    ADMIN_STATS: '/admin-api/stats/',
    ADMIN_CLIENT_GROWTH_CHART: '/admin-api/client-growth-chart/',
    ADMIN_TOKEN_CONSUMPTION_CHART: '/admin-api/token-consumption-chart/',
    ADMIN_SYSTEM_LOGS: '/admin-api/system-logs/',
    ADMIN_LOGS: '/admin-api/logs/',
    
    // Department Management Endpoints
    ADMIN_DEPARTMENTS: '/admin-api/departments/',
    ADMIN_DEPARTMENT_DETAIL: (id) => `/admin-api/departments/${id}/`,
    ADMIN_DEPARTMENT_CREATE: '/admin-api/departments/create/',
    ADMIN_DEPARTMENT_UPDATE: (id) => `/admin-api/departments/${id}/update/`,
    ADMIN_DEPARTMENT_DELETE: (id) => `/admin-api/departments/${id}/delete/`,
    
    // Department Phone Numbers Endpoints
    ADMIN_DEPARTMENT_PHONES: (departmentId) => `/admin-api/departments/${departmentId}/phone-numbers/`,
    ADMIN_DEPARTMENT_PHONE_CREATE: (departmentId) => `/admin-api/departments/${departmentId}/phone-numbers/`,
    ADMIN_DEPARTMENT_PHONE_UPDATE: (departmentId, phoneId) => `/admin-api/departments/${departmentId}/phone-numbers/${phoneId}/`,
    ADMIN_DEPARTMENT_PHONE_DELETE: (departmentId, phoneId) => `/admin-api/departments/${departmentId}/phone-numbers/${phoneId}/`,
    
    // Transfer System Endpoints
    ADMIN_TRANSFER_STATS: '/admin-api/transfer-stats/',
    ADMIN_TRANSFER_LOGS: '/admin-api/transfer-logs/',
    ADMIN_SUGGESTIONS: '/admin-api/suggestions/',
  },
  
  // Request Configuration
  REQUEST_CONFIG: {
    timeout: 10000, // 10 seconds
    headers: {
      'Content-Type': 'application/json',
    },
  },
  
  // Error Messages
  ERROR_MESSAGES: {
    NETWORK_ERROR: 'خطأ في الاتصال بالخادم',
    UNAUTHORIZED: 'غير مصرح لك بالوصول',
    NOT_FOUND: 'المورد غير موجود',
    SERVER_ERROR: 'خطأ في الخادم',
    VALIDATION_ERROR: 'بيانات غير صحيحة',
  },
};

export default API_CONFIG;
